import { debug }             from './theme/debug.js';
import { helpers }           from './theme/helpers.js';
import { hamburger }         from './theme/components/hamburger.js';
import { tabs }              from './theme/components/tabs.js';
import { modal }             from './theme/components/modal.js';
import { map }               from './theme/components/map.js';
import { stickyNavigation }  from './theme/components/sticky-navigation.js';
import { fullscreenVideo }   from './theme/components/fullscreen-video.js';
import { posts }             from './theme/components/posts.js';
import { help }              from './theme/components/help.js';
import { contentSlider }     from './theme/components/content-slider.js';
import { blogMedia }         from './theme/components/blog-media.js';
import { copyLink }          from './theme/components/copy-link.js';
import { disableRightClick } from './theme/components/disable-right-click.js';
import { order }             from './theme/components/order.js';
import { accordion }         from './theme/components/accordion.js';
import { pagerClamp }        from './theme/components/pager-clamp.js';

window.theme = {
    globals: {
        enablePjax: true,
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        var theme = this;

        //Global
        theme.smoothScroll.init();
        theme.responsiveBackgroundImage.init();

        modal.init();
        tabs.init();
        hamburger.init();
        map.init();
        stickyNavigation.init();
        fullscreenVideo.init();
        posts.init();
        help.init();
        contentSlider.init();
        blogMedia.init();
        copyLink.init();
        disableRightClick.init();
        order.init();
        accordion.init();
        pagerClamp.init();

        // fuck coockies
        jQuery( '.cn-button.button' ).removeClass( 'cn-button' );

        $( document.body ).addClass( 'loaded' );

        if ( theme.globals.isTouch === true ) {
            $( document.body ).addClass( 'touch-device' );
        }
        else {
            $( document.body ).addClass( 'pointer-device' );
        }
    },
    smoothScroll: {
        init: function() {
            if ( window.location.hash ) {
                setTimeout( function() {
                    var top = $( window.location.hash ).offset().top;
                    window.scrollTo( 0, top - 120 );
                }, 50 );
            }
        }
    },
    responsiveBackgroundImage: {
        selector: '*[data-mobile-background-image]',
        init: function() {
            var self = this,
                $elements = $( self.selector ),
                viewportWidth = $( window ).width();

            $elements.each( function() {
                var $element = $( this ),
                    mobileBackgroundImageUrl = $element.attr( 'data-mobile-background-image' );

                if ( viewportWidth <= 768 ) {
                    $element.css( 'background-image', 'url("' + mobileBackgroundImageUrl + '")' );
                }
            } );
        }
    }
}

window.onYouTubeIframeAPIReady = function() {
    jQuery( document.body ).trigger( 'youtube' );
};

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
